import { styled, IconButton as MuiIconButton } from "@mui/material";
import { NavigationMenuButtonProps } from "./NavigationMenuButton.props";

export const NavigationMenuButton = styled(({ active, ...props }: NavigationMenuButtonProps) => (
  <MuiIconButton {...props} aria-expanded={Boolean(active)}>
    <span className="burger" aria-hidden>
      <span />
      <span />
      <span />
    </span>
  </MuiIconButton>
))(
  ({
    theme: {
      palette: { custom }
    },
    active
  }) => {
    const color = active ? custom.turquoise.main : custom.white.main;

    // When open, the outer bars move onto the middle bar and rotate into a cross while the middle bar fades out.
    return `
      color: ${color};
      transition: color 200ms ease-in-out;

      & .burger {
        position: relative;
        display: block;
        width: 24px;
        height: 24px;
      }

      & .burger > span {
        position: absolute;
        left: 3px;
        width: 18px;
        height: 2px;
        border-radius: 1px;
        background-color: currentColor;
        transition: transform 200ms ease-in-out, opacity 200ms ease-in-out;
      }

      & .burger > span:nth-of-type(1) {
        top: 5px;
        transform: ${active ? "translateY(6px) rotate(45deg)" : "none"};
      }

      & .burger > span:nth-of-type(2) {
        top: 11px;
        opacity: ${active ? 0 : 1};
      }

      & .burger > span:nth-of-type(3) {
        top: 17px;
        transform: ${active ? "translateY(-6px) rotate(-45deg)" : "none"};
      }

      @media (prefers-reduced-motion: reduce) {
        &,
        & .burger > span {
          transition: none;
        }
      }
    `;
  }
);
